<div class="document-request" (click)="selectDocumentRequest.emit()">
  <div class="document-request__header">
    <div class="line">
      <div
        class="document-request__header--module-type">{{ documentRequest().moduleType | documentRequestModuleTypeLabel }}
      </div>
      <div class="document-request__header--date">au {{ accountingPeriod()?.endDate | date: 'dd/MM/yyyy' }}</div>
      <button
        tiime-button
        class="close-request-button"
        color="primary"
        strocked
        (click)="onCloseDocumentRequestClick($event)"
      >
        @if (documentRequest().closedAt) {
          Déclôturer
        } @else {
          Clôturer
        }
      </button>
    </div>
    @if (documentRequest().closedAt) {
      <div class="document-request__header--closed line">
        Clôturé le {{ documentRequest().closedAt | date: 'dd/MM/yyyy' }}
        à {{ documentRequest().closedAt | date: 'HH:mm' }}
        par {{ documentRequest().closedBy.fullName }}
      </div>
    } @else {
      <div class="document-request__header--status line">
        {{ documentRequest().status | documentRequestStatusLabel }}
        le {{ documentRequest().statusUpdatedAt | date: 'dd/MM/yyyy' }}
        à {{ documentRequest().statusUpdatedAt | date: 'HH:mm' }}
        par {{ documentRequest().statusUpdatedBy.fullName }}
      </div>
    }
  </div>
</div>
